import "core-js/modules/es.array.map.js";
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
import CurationItem from './CurationItem';
function CurationDropdown(_ref) {
  var data = _ref.data,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(DetailsDropdown, {
    titleKey: "panel_curation_checklist_title",
    listLayout: "stack",
    listItems: data.map(function (item) {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: item.fieldTranslationKey
      }, /*#__PURE__*/React.createElement(CurationItem, {
        isComplete: item.exists
      }, t(item.fieldTranslationKey)));
    })
  }, children);
}
export default CurationDropdown;